<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 10px; margin-bottom: 5px">
            <el-breadcrumb-item :to="{ path: '/commodityFlowAdjustmentList' }">流向调整</el-breadcrumb-item>
            <el-breadcrumb-item>流向调整行</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.flow_rid" placeholder="请输入流向RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ is_all: true, type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_flow_adjustment_line"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['xxxxx'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../../js/common.js';
import draggableList from '../../../../common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect
    },
    name: 'commodityFlowAdjustmentLineComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_flow_adjustment_line'
            },
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            selected: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        //this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['flow_rid']) && row.flow_rid) {
                this.$router.push({
                    path: '/commodityFlowDetail',
                    query: {
                        id: row.flow_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_flow_adjustment_line_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.flow_adjustment_rid = this.postList.params.flow_adjustment_rid || '';
                this.getList(0);
            } else {
                this.queryParams.row = 25;
                this.getList(0); //获取列表
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow_adjustment_line', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow_adjustment_line;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'commodityFlowAdjustmentLineLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.partner_rid_ref && this.$refs.partner_rid_ref.reset();
            this.$refs.product_rid_ref && this.$refs.product_rid_ref.reset();
            this.$refs.business_rid_ref && this.$refs.business_rid_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>